// src/services/validatorApi.js
import axios from "axios";

const API_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:8000/";

// Create an axios instance with shared configuration
const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

const validatorApi = {
  // Submit idea for validation
  validateIdea: async (idea, industry) => {
    try {
      const response = await apiClient.post("/validator/validate/", {
        idea,
        industry: industry || "",
      });
      return { success: true, data: response.data };
    } catch (error) {
      // Handle rate limit errors specifically
      if (error.response && error.response.status === 429) {
        return {
          success: false,
          rateLimit: true,
          error: "Rate limit exceeded. Please try again later.",
        };
      }

      console.error("Error validating idea:", error);
      return {
        success: false,
        error: error.response?.data?.error || "Failed to validate idea",
      };
    }
  },
  // Get validation results by ID
  getValidationResult: async (validationId) => {
    try {
      // Clean the ID by removing any trailing slashes
      const cleanId = validationId.replace(/\/$/, "");

      // Use the exact same URL pattern that's confirmed working
      const response = await apiClient.get(`/validator/${cleanId}/result/`);
      return { success: true, data: response.data };
    } catch (error) {
      console.error("Error fetching validation result:", error);
      return {
        success: false,
        error: error.response?.data?.error || "Failed to fetch results",
      };
    }
  },

  // Submit feedback on a validation result

  // Update the submitFeedback function with better error logging
  submitFeedback: async (resultId, feedbackType) => {
    try {
      console.log("Submitting feedback with:", { result: resultId, feedback_type: feedbackType });

      const response = await apiClient.post("/validatorfeedback/", {
        result: resultId,
        feedback_type: feedbackType,
      });
      return { success: true, data: response.data };
    } catch (error) {
      // Enhanced error logging
      console.error("Error submitting feedback:", error);
      if (error.response) {
        console.error("Response status:", error.response.status);
        console.error("Response data:", error.response.data);
      }

      // Handle rate limit errors
      if (error.response && error.response.status === 429) {
        return {
          success: false,
          rateLimit: true,
          error: "Rate limit exceeded for feedback submissions.",
        };
      }

      return {
        success: false,
        error: error.response?.data?.error || "Failed to submit feedback",
      };
    }
  },
  //   submitFeedback: async (resultId, feedbackType) => {
  //     try {
  //       const response = await apiClient.post("/validatorfeedback/", {
  //         result: resultId,
  //         feedback_type: feedbackType, // 'helpful' or 'not_helpful'
  //       });
  //       return { success: true, data: response.data };
  //     } catch (error) {
  //       // Handle rate limit errors
  //       if (error.response && error.response.status === 429) {
  //         return {
  //           success: false,
  //           rateLimit: true,
  //           error: "Rate limit exceeded for feedback submissions.",
  //         };
  //       }

  //       console.error("Error submitting feedback:", error);
  //       return { success: false, error: "Failed to submit feedback" };
  //     }
  //   },
};

export default validatorApi;
